import { connect } from "react-redux";
import { default as component } from "./ContentOrdersRecentlyPublishedTable.jsx";

// local selectors and actions
import {
  getRecentlyPublishedContentOrdersFiltered,
  isLoading,
} from "../../duck/selectors";

const mapStateToProps = (state) => {
  return {
    isLoading: isLoading(state),
    contentOrders: getRecentlyPublishedContentOrdersFiltered(state),
  };
};

export default connect(mapStateToProps, null)(component);
